import { apiClient } from "../config/api.client";
import { USER_COMPLETE_REGISTRATION, USER_MARKETING_CONSENT, USER_ME, USER_SEND_OTP, USER_VERIFY_OTP } from "../constants/api.constant";

export const getUser = async () => {
    try {
        const { data } = await apiClient.get(USER_ME);
        return data;
    } catch (error) {
        console.log("Error Fetching User :", error);
        throw error;
    }
}

export const sendOtp = async (phone) => {
    try {
        const { data } = await apiClient.post(
            USER_SEND_OTP,
            { phone },
            { headers: { "Content-Type": "application/json" }}
        );
        console.log(data);
        return data;
    } catch (error) {
        console.log("Error Sending OTP :", error);
        throw error;
    }
}

export const verifyOtp = async (phone, otp) => {
    try {
        const { data } = await apiClient.post(
            USER_VERIFY_OTP,
            { phone, otp },
            { headers: { "Content-Type": "application/json" }}
        );
        return data;
    } catch (error) {
        console.log("Error Verifying OTP :", error);
        throw error;
    }
}

export const completeRegistration = async (phone, name, email, password, referralSource, registrationToken, marketingConsent = false) => {
    try {
        const { data } = await apiClient.post(
            USER_COMPLETE_REGISTRATION,
			{ phone, name, email, password, referralSource, registrationToken, marketingConsent },
            { headers: { "Content-Type": "application/json" }}
        );
        return data;
    } catch (error) {
        console.log("Error Completing Registration :", error);
        throw error;
    }
}

export const getMarketingConsent = async () => {
    try {
        const { data } = await apiClient.get(USER_MARKETING_CONSENT);
        return data;
    } catch (error) {
        console.log("Error Fetching Marketing Consent :", error);
        throw error;
    }
}

export const updateMarketingConsent = async (marketingConsent) => {
    try {
        const { data } = await apiClient.put(
            USER_MARKETING_CONSENT,
            { marketingConsent: !!marketingConsent },
            { headers: { "Content-Type": "application/json" }}
        );
        return data;
    } catch (error) {
        console.log("Error Updating Marketing Consent :", error);
        throw error;
    }
}
